export default __webpack_public_path__ + "static/media/appMarvel.64b7540e.jpg";